export default __webpack_public_path__ + "static/media/BootsSharp-Regular.e8306369.eot";